import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalWindow from '../../../layout/modalwindow/ModalWindow'
import NumberOfLogsForm from './forms/NumberOfLogsForm'
import { appContext } from '../../../../App'

function Miscellaneous(props) {
  const app = useContext(appContext)
  const [showHeader, setShowHeader] = useState(true)

  const onClickHeader = (e) => { setShowHeader(!showHeader) }

  const onClickSystemLogs = (e) => {
    // Show form here asking for number of records/logs to generate before proceeding
    const showNumberOfLogsForm = () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='20'
          width='20'
          header='Set Number Of Logs'
          footer='limit number of logs to show...'>
          <NumberOfLogsForm app={app} />
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    showNumberOfLogsForm()
  }

  return (
    <React.Fragment>
      <div className='report-item-container'>
        <button id='miscellaneous' onClick={onClickHeader} className='report-item-header'>
          Miscellaneous &nbsp;<span style={{marginTop: '2px'}}><FontAwesomeIcon icon={(showHeader) ? 'caret-down' : 'caret-right'}/></span>
        </button>
        <div className={(showHeader) ? 'report-items-container' : 'hide-ric'}>
          <button
            id='logs-btn'
            onClick={onClickSystemLogs}
            className='report-item-wrapper'>
            <div className='report-item-title'>System Logs</div>
            <div className='report-item-description'>
              Show's the last 1,000 logs by default.
            </div>
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default React.memo(Miscellaneous)